import { Checkbox, Col, Form, Row, Select } from "antd"
import { FormInstance } from "antd/lib/form"
import React, { useState } from "react"
import { createCreditCardRules } from "~Components/forms/rules/creditCard.rules"
import { usePagedCards } from "~Shared/hooks/creditCard.hooks"
import { EmployeeService } from "~Shared/services"
import { WeavrCardBlockedReason, WeavrCardDestroyedReason, WeavrCardState } from "~Shared/services/simulator.service"

export const SimlatorCardStateChange = ({ formInstance }: { formInstance: FormInstance<any> }) => {
    const { cards } = usePagedCards(1, 10000)
    const rules = createCreditCardRules()
    const [cardState, setCardState] = useState(formInstance.getFieldValue("weavrCardState") ?? WeavrCardState.ACTIVE)

    const filterSelect = (input: string, option: any) => {
        const value = option?.children?.props?.children || ""
        return value.toLowerCase().indexOf(input.toLowerCase()) > -1
    }

    const updateCardState = (state: WeavrCardState) => {
        switch (state) {
            case WeavrCardState.ACTIVE:
                formInstance.setFieldsValue({
                    weavrCardBlockedReason: null,
                    weavrCardDestroyedReason: null,
                })
                break
            case WeavrCardState.BLOCKED:
                formInstance.setFieldsValue({
                    weavrCardDestroyedReason: null,
                })
                break
            case WeavrCardState.DESTROYED:
                formInstance.setFieldsValue({
                    weavrCardBlockedReason: null,
                })
                break
            default:
                break
        }
        setCardState(state)
    }

    return (
        <>
            <Row>
                <Col span={24} className="px-5">
                    <Form.Item label="Card" name="card" rules={rules.card} initialValue={cards[0]?._id}>
                        <Select showSearch filterOption={filterSelect}>
                            {cards.map((card: any) => {
                                const employee = EmployeeService.getEmployeeById(card.user)
                                return (
                                    <Select.Option key={card._id} value={card._id}>
                                        <span>{`**** **** **** ${card.last4Digits} - Holder: ${employee?.firstName} ${employee?.lastName} - Limit: ${card.limit} - Balance: ${card.balance}`}</span>
                                    </Select.Option>
                                )
                            })}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={8} className="px-5">
                    <Form.Item className="w-full" name="weavrCardState" label="Card state" initialValue={cardState}>
                        <Select showSearch onChange={(val: WeavrCardState) => updateCardState(val)}>
                            {Object.values(WeavrCardState).map((e) => (
                                <Select.Option key={e} value={e}>
                                    {e}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={8} className="px-5">
                    <Form.Item className="w-full" name="weavrCardBlockedReason" label="Blocked reason" required={cardState === WeavrCardState.BLOCKED}>
                        <Select showSearch disabled={cardState !== WeavrCardState.BLOCKED}>
                            {Object.values(WeavrCardBlockedReason).map((e) => (
                                <Select.Option key={e} value={e}>
                                    {e}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={8} className="px-5">
                    <Form.Item className="w-full" name="weavrCardDestroyedReason" label="Destroyed reason" required={cardState === WeavrCardState.DESTROYED}>
                        <Select showSearch disabled={cardState !== WeavrCardState.DESTROYED}>
                            {Object.values(WeavrCardDestroyedReason).map((e) => (
                                <Select.Option key={e} value={e}>
                                    {e}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={8} className="px-5">
                    <Form.Item className="w-full" name="shouldSimulateOnWeavr" initialValue={false} valuePropName="checked">
                        <Checkbox>Simulate on Weavr</Checkbox>
                    </Form.Item>
                </Col>
                <Col span={16} className="px-5">
                    <p className="finway-red-text text-bold">Info: This triggers card status change on weavr after simulating webhook</p>
                    {cardState === WeavrCardState.BLOCKED && (
                        <p className="finway-red-text text-bold">Note: Simulation will do nothing if card is already SUSPENDED or TERMINATED</p>
                    )}
                    {cardState === WeavrCardState.DESTROYED && (
                        <>
                            <p className="finway-red-text text-bold">Note: Simulation will do nothing if card is already TERMINATED</p>
                            <p className="finway-red-text text-bold">Note: Weavr API cannot simulate LOST or STOLEN card will be TERMINATED instead</p>
                        </>
                    )}
                </Col>
            </Row>
        </>
    )
}
